import React from "react";
import WebResourceImage from "../../WebResourceImage";
import { CanotisBOSIco, DatabaseIco } from "../../../localResouces";

// Externals
import cn from "classnames";

// DevExtreme components
import Button from 'devextreme-react/button';
import { Template } from 'devextreme-react/core/template';

// Component styles
import classes from "./Tiles.module.scss";

function Apps(props) {
  const { solutions, currentDataSegmentId, onDataClick, openHint } = props;

  const renderSolutions = () => {
    if (solutions) {
      return (
        solutions.map((solution) => (
          renderDatasForSolution(solution)
        ))
      );
    }
  };

  const renderDatasForSolution = (solution) => {
    if (solution.datas) {
      return (
        solution.datas.map((data) => (
          renderTile(solution, data)
        ))
      );
    }
  };

  const renderTile = (solution, data) => {
    return (
      <Button
        key={data.globalDatasegmentId}
        className={classes.tileButton}
        onClick={e => onDataClick(e, solution, data)}
        hint={openHint}
        disabled={data.globalDatasegmentId === currentDataSegmentId}
        template={'btn'}
      >
        <Template name='btn'>
          <div className={classes.buttonContentContainer}>
            <div className={classes.buttonContentSolutionImageContainer}>
              <WebResourceImage size={"48px"} fallBackImage={CanotisBOSIco} fileId={solution.iconExternalDocId} />
            </div>
            <div className={classes.buttonContentSolutionTextContainer}>
              <div className={cn(classes.text, "ui-font-bigger-1", "ui-font-bold-1")}>
                {solution.displayName}
              </div>
            </div>
            <div className={classes.buttonContentDataImageContainer}>
              <WebResourceImage size={"32px"} fallBackImage={DatabaseIco} fileId={data.iconExternalDocId} />
            </div>
            <div className={classes.buttonContentDataTextContainer}>
              <p className={cn(classes.textData, "dx-theme-accent-as-text-color")}>
                {data.displayName}
              </p>
            </div>
          </div>
        </Template>
      </Button>
    );
  }

  return (
    <div className={classes.tileDiv}>
      {renderSolutions()}
    </div>
  );
}

export default (Apps);